// extracted by mini-css-extract-plugin
export default {"text":"delbtn_text__B2pAn","icon":"delbtn_icon__gZR5Q"};